export type DgaLockMessage = {
  type: "TAKEOVER_REQUESTED";
  appId: string;
  senderId: string;
};

export type DgaRefreshMessage = {
  type: "REFRESH_LIST";
  senderId: string;
};

export type DgaChannelMessage = DgaLockMessage | DgaRefreshMessage;

export interface DgaLockChannel {
  postTakeover: (appId: string) => void;
  postRefresh: () => void;
  subscribe: (onTakeover: (appId: string) => void) => () => void;
  subscribeRefresh: (onRefresh: () => void) => () => void;
  close: () => void;
}

export function createDgaLockChannel(dealerId: string): DgaLockChannel {
  const channel = new BroadcastChannel(`porchpass-dga-lock-${dealerId}`);
  const senderId = crypto.randomUUID();

  return {
    postTakeover(appId) {
      const msg: DgaLockMessage = {
        type: "TAKEOVER_REQUESTED",
        appId,
        senderId,
      };
      channel.postMessage(msg);
    },
    postRefresh() {
      const msg: DgaRefreshMessage = {
        type: "REFRESH_LIST",
        senderId,
      };
      channel.postMessage(msg);
    },
    subscribe(onTakeover) {
      const handler = (event: MessageEvent<DgaChannelMessage>) => {
        const msg = event.data;
        if (msg.type !== "TAKEOVER_REQUESTED") return;
        if (msg.senderId === senderId) return;
        onTakeover(msg.appId);
      };
      channel.addEventListener("message", handler);
      return () => channel.removeEventListener("message", handler);
    },
    subscribeRefresh(onRefresh) {
      const handler = (event: MessageEvent<DgaChannelMessage>) => {
        const msg = event.data;
        if (msg.type !== "REFRESH_LIST") return;
        if (msg.senderId === senderId) return;
        onRefresh();
      };
      channel.addEventListener("message", handler);
      return () => channel.removeEventListener("message", handler);
    },
    close() {
      channel.close();
    },
  };
}
